<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="142.331"
        height="320"
        viewBox="0 0 142.331 320"
    >
        <defs>
            <clipPath id="clip-path">
                <rect
                    id="Rechteck_219"
                    data-name="Rechteck 219"
                    width="142.331"
                    height="320"
                    fill="none"
                />
            </clipPath>
        </defs>
        <g
            id="Gruppe_43"
            data-name="Gruppe 43"
            clip-path="url(#clip-path)"
        >
            <path
                id="Pfad_634"
                data-name="Pfad 634"
                d="M54.53,109.06a54.53,54.53,0,1,1,54.53-54.53,54.592,54.592,0,0,1-54.53,54.53m0-103.525A48.993,48.993,0,1,0,103.525,54.53,49.05,49.05,0,0,0,54.53,5.535"
                fill="#1d1d1b"
            />
            <path
                id="Pfad_635"
                data-name="Pfad 635"
                d="M40.69,44.75C21.8,44.75,7.707,27.318,7.113,26.574a2.768,2.768,0,0,1,4.328-3.453c.131.163,13.245,16.305,29.566,16.091,9.288-.118,18.049-5.513,26.04-16.037a2.768,2.768,0,1,1,4.411,3.344C62.371,38.49,52.138,44.62,41.042,44.75H40.69"
                transform="translate(14.283 48.445)"
                fill="#1d1d1b"
            />
            <path
                id="Pfad_636"
                data-name="Pfad 636"
                d="M16.747,26.745A7.846,7.846,0,1,1,24.595,18.9a7.856,7.856,0,0,1-7.847,7.847m0-10.968a3.122,3.122,0,1,0,3.124,3.12,3.126,3.126,0,0,0-3.124-3.12"
                transform="translate(19.526 24.25)"
                fill="#1d1d1b"
            />
            <path
                id="Pfad_637"
                data-name="Pfad 637"
                d="M28.568,26.279a7.847,7.847,0,1,1,7.847-7.847,7.856,7.856,0,0,1-7.847,7.847m0-10.971a3.122,3.122,0,1,0,3.124,3.124,3.126,3.126,0,0,0-3.124-3.124"
                transform="translate(45.46 23.221)"
                fill="#1d1d1b"
            />
            <path
                id="Pfad_638"
                data-name="Pfad 638"
                d="M5.753,151.971A2.769,2.769,0,0,1,3.425,147.7C37.584,94.585,45.166,38.107,45.24,37.545a2.769,2.769,0,0,1,5.018-1.23c1.2,1.725,29.311,42.99,25.475,112.4A2.767,2.767,0,0,1,73,151.329l-67.216.642Zm67.213-3.411h0ZM49.45,45.817C46.236,62.678,36.2,105.093,10.793,146.384l59.538-.565c2.223-50.79-13.462-86.249-20.882-100"
                transform="translate(6.546 77.066)"
                fill="#1d1d1b"
            />
            <path
                id="Pfad_639"
                data-name="Pfad 639"
                d="M16.658,132.8c-4.912,0-7.451-2.051-8.729-3.83-3.868-5.395-.61-14.015-.224-14.98a2.732,2.732,0,0,1,.3-.562L38.974,69.168a2.808,2.808,0,0,1,2.753-1.14l60.42,10.709c.153.032,6.126,1.239,9.866-1.8,2.194-1.776,3.3-4.816,3.3-9.039V22.92a2.771,2.771,0,0,1,5.541,0V67.9c0,5.992-1.814,10.489-5.385,13.367-5.829,4.7-14.05,2.98-14.4,2.906L42.5,73.787,12.742,116.323c-.715,1.977-2.019,7.055-.31,9.428.811,1.124,2.472,1.626,4.922,1.495,13.089-.693,68.139-13.37,68.7-13.5a2.769,2.769,0,0,1,1.242,5.4c-2.284.527-56.079,12.913-69.644,13.632-.339.016-.671.026-.99.026"
                transform="translate(13.285 44.21)"
                fill="#1d1d1b"
            />
            <path
                id="Pfad_640"
                data-name="Pfad 640"
                d="M48.661,39.506A10.96,10.96,0,1,1,59.622,28.544,10.976,10.976,0,0,1,48.661,39.506m0-16.385a5.423,5.423,0,1,0,5.423,5.423,5.429,5.429,0,0,0-5.423-5.423"
                transform="translate(82.709 38.583)"
                fill="#1d1d1b"
            />
            <path
                id="Pfad_641"
                data-name="Pfad 641"
                d="M39.178,68.225A10.96,10.96,0,1,1,50.139,57.263,10.976,10.976,0,0,1,39.178,68.225m0-16.385A5.423,5.423,0,1,0,44.6,57.263a5.429,5.429,0,0,0-5.423-5.423"
                transform="translate(61.904 101.59)"
                fill="#1d1d1b"
            />
            <path
                id="Pfad_642"
                data-name="Pfad 642"
                d="M63.491,12.166s4.721,46.306-20.109,75.917L31.648,84.975s.246-17.659,6.4-24.156l8.473,2.245,7.86-29.678L44.069,30.656S46.107,12.732,49.917,8.57Z"
                transform="translate(69.434 18.802)"
                fill="#fff"
            />
            <path
                id="Pfad_643"
                data-name="Pfad 643"
                d="M45.028,92.122a2.36,2.36,0,0,1-.613-.08L32.684,88.935A2.4,2.4,0,0,1,30.9,86.587c.013-.76.339-18.678,7.055-25.769a2.391,2.391,0,0,1,2.351-.671l6.161,1.632L53.1,36.733l-8-2.118a2.394,2.394,0,0,1-1.766-2.587C43.69,28.905,45.67,13.1,49.8,8.6a2.406,2.406,0,0,1,2.379-.7l13.574,3.6a2.39,2.39,0,0,1,1.769,2.073c.2,1.932,4.535,47.657-20.655,77.7a2.4,2.4,0,0,1-1.837.856m-9.272-7.33,8.394,2.223c20.3-25.395,19.237-63.064,18.726-71.327L52.582,12.964c-1.776,3.382-3.4,11.377-4.232,17.557l8.291,2.194a2.426,2.426,0,0,1,1.46,1.111,2.4,2.4,0,0,1,.243,1.817l-7.86,29.678a2.381,2.381,0,0,1-2.929,1.7l-6.985-1.849c-3.35,4.772-4.535,14.414-4.813,19.617"
                transform="translate(67.788 17.158)"
            />
            <line
                id="Linie_1"
                data-name="Linie 1"
                x2="0.351"
                y2="87.68"
                transform="translate(79.512 225.627)"
                fill="#1d1d1b"
            />
            <path
                id="Pfad_644"
                data-name="Pfad 644"
                d="M26.889,162.363a2.394,2.394,0,0,1-2.4-2.386L24.145,72.3a2.4,2.4,0,0,1,2.386-2.405h.01a2.4,2.4,0,0,1,2.4,2.386l.348,87.68a2.4,2.4,0,0,1-2.386,2.405Z"
                transform="translate(52.972 153.338)"
            />
            <line
                id="Linie_2"
                data-name="Linie 2"
                y2="88.894"
                transform="translate(12.298 226.268)"
                fill="#1d1d1b"
            />
            <path
                id="Pfad_645"
                data-name="Pfad 645"
                d="M5.5,163.777a2.4,2.4,0,0,1-2.4-2.4V72.488a2.4,2.4,0,1,1,4.791,0v88.894a2.4,2.4,0,0,1-2.4,2.4"
                transform="translate(6.803 153.779)"
            />
            <path
                id="Pfad_646"
                data-name="Pfad 646"
                d="M56.155,108.288H26.279a2.07,2.07,0,0,1-1.619-3.357c5.522-6.95,11.415-10.32,17.468-10.01,9.448.482,15.516,9.786,15.772,10.182a2.068,2.068,0,0,1-1.744,3.184m-25.248-4.136H51.763c-2.22-2.248-5.692-4.893-9.869-5.1-3.641-.188-7.33,1.536-10.987,5.1"
                transform="translate(53.119 208.208)"
            />
            <path
                id="Pfad_647"
                data-name="Pfad 647"
                d="M35.146,109.383H5.27a2.07,2.07,0,0,1-1.619-3.357c5.522-6.947,11.377-10.294,17.468-10.01,9.444.482,15.516,9.786,15.768,10.182a2.068,2.068,0,0,1-1.741,3.184M9.9,105.247H30.754c-2.223-2.248-5.692-4.893-9.869-5.1-3.622-.105-7.327,1.536-10.987,5.1"
                transform="translate(7.027 210.617)"
            />
        </g>
    </svg>
</template>

<script setup lang="ts">
</script>
